// This file is generated.
export var version = '0.2.3';
//# sourceMappingURL=version.js.map